// extracted by mini-css-extract-plugin
export default {"mCard":"LD-z","image":"MD-z","imageNoBackground":"ND-z","imageHasCategory":"OD-z","fullWidth":"PD-z"};